<div class="row pb-2 d-none d-md-flex" *ngIf="!!mappedData">
  <div *ngIf="amountOfCredit?.creditLeft" class="alert alert-warning w-100 text-center" role="alert">
    {{ 'AMOUNT_OF_CREDIT_LEFT' | translate: { creditLeft: amountOfCredit.creditLeft } }}
  </div>
  <div class="col-10 text-right">
    <div class="row">
      <div class="col">
        <span translate>REQUEST_DELIVERY_DATE</span>
      </div>
    </div>
  </div>
  <div class="col-2">
    <lib-delivery-date-picker
      class="request-delivery-date"
      [initialDate]="minDeliveryDate"
      [minInitialDate]="minDeliveryDate"
      (selectedDate)="dateSelected($event)"
    >
    </lib-delivery-date-picker>
  </div>
</div>
<div class="row pb-2 d-none d-md-flex">
  <div class="col-3 col-lg-1"></div>
  <div class="d-none d-xl-block col-12 col-md-6 col-lg-7 col-xl-4"></div>
  <div class="d-none d-xl-block col-4 col-lg-3 col-xl-2">
    <b *ngIf="!isUser" translate>QUANTITY</b>
    <b *ngIf="isUser" translate>REQUESTED_QUANTITY</b>
  </div>
  <div class="d-none d-xl-block col-4 col-lg-3 col-xl-2">
    <b *ngIf="!isUser" translate>PRICE</b>
    <b *ngIf="isUser" translate>UNIT_PRICE</b>
  </div>
  <div class="d-none d-xl-block col-4 col-lg-3 col-xl-1" *ngIf="!isUser">
    <b translate>DISCOUNT_PERCENT</b>
  </div>
  <div class="d-none d-xl-block col-4 col-lg-3 col-xl-1">
    <b *ngIf="!isUser" translate>TOTAL</b>
    <b *ngIf="isUser" translate>TOTAL</b>
  </div>
  <div class="col-1"></div>
</div>
<span *ngFor="let row of mappedData; index as index; trackBy: trackByFn">
  <div class="row pb-2 align-items-center">
    <div
      class="col-3 col-lg-1 d-flex align-items-center navigate-to-product-details"
      routerLink="/product/{{ row.product.id }}"
    >
      <img
        class="img-fluid"
        src="https://d27ahaa1qqlr90.cloudfront.net/fit-in/64x64/filters:fill(white):background_color(white):format(jpeg)/{{
          row.product.extra.images[0].s3Uri
        }}"
        alt=""
      />
    </div>

    <div
      class="col-8 text-truncate navigate-to-product-details col-lg-7 col-xl-4"
      routerLink="/product/{{ row.product.id }}"
    >
      <div>
        <b>{{ row.product.id }}</b> - {{ row.product.name }}
      </div>
      <small class="d-none">{{ row.productPartialId }}</small>
      <div class="pb-sm-4 pb-lg-0">
        <button
          class="btn btn-primary btn-sm"
          (click)="$event.preventDefault(); $event.stopPropagation(); editNote(row.cartRow)"
        >
          <span translate>EDIT_NOTE</span>
        </button>
      </div>
    </div>

    <div class="col-12 col-sm-8 col-lg-3 col-xl-2 offset-sm-3 offset-lg-0 col-request-quantity">
      <div class="row pt-1">
        <div class="col-4 d-flex d-xl-none">
          <b translate>QUANTITY</b>
        </div>
        <div class="col-8 col-xl-12">
          <lib-buy-btn
            [id]="row.product.id"
            [productPartialId]="row.productPartialId"
            [targetStockId]="row.targetStockId"
          ></lib-buy-btn>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-8 col-lg-3 col-xl-2 offset-sm-3 offset-lg-0">
      <div class="row pt-1" *ngIf="!isUser">
        <div class="col-4 d-flex d-xl-none">
          <b translate>PRICE</b>
        </div>
        <div class="col-8 col-xl-12 d-flex">
          <input
            type="number"
            class="form-control"
            [value]="parseFloatFixed(row.overridePrice, 2)"
            [placeholder]="row.originalPrice | number: '1.2-2'"
            (blur)="updateOverridePrice(row, parseFloatFixed($event.target.value, 2))"
          />
        </div>
      </div>
      <div class="row pt-1" *ngIf="isUser">
        <div class="col-4 d-flex d-lg-none">
          <b translate>UNIT_PRICE</b>
        </div>
        <div class="col-8 col-lg-12 d-flex">
          <b>
            {{
              row.price.cartRowUnitPrice.value
                | gungCurrency: row.price.cartRowUnitPrice.currencyCode:'symbol-narrow':'1.2-2'
            }}
            <span *ngIf="row.price.cartRowDiscountPercent !== 0"
              >(-{{ parseFloatFixed(row.price.cartRowDiscountPercent, 2) }}%)</span
            >
          </b>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-8 col-lg-3 col-xl-1 offset-sm-3 offset-lg-1 offset-xl-0" *ngIf="!isUser">
      <div class="row pt-1">
        <div class="col-4 d-flex d-xl-none">
          <b translate>DISCOUNT_PERCENT</b>
        </div>
        <div class="col-8 col-xl-12 d-flex">
          <input
            type="number"
            class="form-control discount-control"
            [value]="parseFloatFixed(row.discountPercent || row.cartRowPriceElement.cartRowDiscountPercent || 0, 2)"
            (blur)="updateDiscountPercentage(row, $event.target.value, true)"
            placeholder="%"
          />
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-8 col-lg-3 col-xl-1 offset-sm-3 offset-lg-1 offset-xl-0">
      <div class="row pt-1" *ngIf="!isUser">
        <div class="col-4 d-flex d-xl-none">
          <b translate>TOTAL</b>
        </div>
        <div class="col-8 col-xl-12 d-flex">
          {{
            row.cartRowPriceElement.cartRowTotalPriceInclRowDiscount.value
              | gungCurrency: row.cartRowPriceElement.cartRowTotalPriceInclRowDiscount.currencyCode
          }}
        </div>
      </div>
      <div class="row pt-1" *ngIf="isUser">
        <div class="col-4 d-flex d-xl-none">
          <b translate>TOTAL_PRICE</b>
        </div>
        <div class="col-8 col-md-6 d-flex">
          {{
            row.price.cartRowTotalPriceInclRowDiscount.value
              | gungCurrency: row.price.cartRowTotalPriceInclRowDiscount.currencyCode
          }}
        </div>
      </div>
    </div>
    <div
      class="col-2 col-md-1 order-first order-xl-0 offset-11 offset-xl-0 d-flex align-items-center col-delete-button"
    >
      <button type="button" class="btn btn-secondary btn-sm mr-1" (click)="duplicateProduct(row, index)">
        <i class="fas fa-copy"></i>
      </button>
      <button class="btn btn-light delete-button" (click)="removeRow(row)">
        <i class="fal fa-minus-circle"></i>
      </button>
      <i
        *ngIf="selectedLanguageCode && row.product.extra.i18n[selectedLanguageCode].transportInfo"
        class="fal fa-exclamation-triangle ml-auto"
        ngbTooltip="{{ row.product.extra.i18n[selectedLanguageCode].transportInfo }}"
      ></i>
    </div>
  </div>
  <div class="row hr"></div>
</span>
<tylo-preliminary-delivery-time-warning></tylo-preliminary-delivery-time-warning>
